export default __webpack_public_path__ + "static/media/103_zip-zap.e0701859.png";